import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import ReactPixel from 'react-facebook-pixel';
ReactPixel.init('2069197916973057');
ReactPixel.pageView();
render(<App data-id="element-233" />, document.getElementById('root'));